import { render } from "./NoRecordsFound.vue?vue&type=template&id=d14ec922&scoped=true"
const script = {}

import "./NoRecordsFound.vue?vue&type=style&index=0&id=d14ec922&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d14ec922"]])

export default __exports__